import { Search as EtSearch, SearchVariant, Size } from "@ever-tutor/et-ui";

interface SearchProps {
  placeholder: string;
  inputClassName?: string;
  value: string;
  onChange: (value: string) => void;
  showClearButton?: boolean;
  height?: string;
  variant?: SearchVariant;
  size?: Size;
}

const Search = ({
  placeholder,
  value,
  onChange,
  showClearButton = true,
  height = "70px",
  inputClassName = "",
  size = Size.MD,
  variant = SearchVariant.DEFAULT,
}: SearchProps) => {
  return (
    <EtSearch
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      showClearButton={showClearButton}
      height={height}
      inputClassName={inputClassName}
      size={size}
      variant={variant}
      aria-label="Search"
    />
  );
};

export default Search;
